<template>
  <div style="background-color: white">
    <Head ref="head"></Head>
    <div class="poundBody">
      <div class="poundBodyMoudle CommissionIsIntroduced" v-if="false">
        <div class="IntroducedfontBox">
          <!-- Commissioni e Livelli Rakumart -->
          <h1 class="sr-only">{{ $fanyi("Rakumart会员等级和佣金费") }}</h1>
          <!-- RAKUMART 的佣金 -->
          <div class="caption-kicker">{{ $fanyi("RAKUMART 的佣金") }}</div>
          <!-- 透明定价、阶梯佣金、成本优化 -->
          <h2>{{ $fanyi("透明定价、阶梯佣金、成本优化") }}</h2>
          <p>
            {{
              $fanyi(
                "以较低成本享受 Rakumart 的所有优势。透明且分级的佣金体系，助力您的业务增长。",
              )
            }}
          </p>
        </div>
        <img
          class="IntroducedfontImg"
          src="../../assets/newImg/footlist/dengji/WechatIMG71.png"
          alt=""
        />
      </div>
      <!-- 手续费规则说明 -->
      <div class="poundBodyMoudle handlingFeeRule">
        <div class="caption">
          <!-- Commissioni e Livelli Rakumart -->
          <h1 class="sr-only">{{ $fanyi("Rakumart会员等级和佣金费") }}</h1>
          <!-- RAKUMART 的佣金 -->
          <div class="caption-kicker">{{ $fanyi("RAKUMART 的佣金") }}</div>
          <div class="captionContent">
            <!-- 增加采购量，降低佣金支付 -->
            <h3>{{ $fanyi("增加采购量，降低佣金支付") }}</h3>
            <p>
              {{
                $fanyi(
                  "佣金百分比将根据您所有已付款订单中商品的累计金额来确定。",
                )
              }}
            </p>
            <p>
              {{
                $fanyi(
                  "例如，如果你的商品采购额超过40,000€，后续订单的佣金率将降至4%，请查看下表了解你的采购对应的百分比：",
                )
              }}
            </p>
          </div>
        </div>
        <div class="handlingFeeForm">
          <div class="tul FeeFormBody">
            <div class="tli FeeFormBody">
              <img
                src="../../assets/newImg/footlist/dengji/WechatIMG76.png"
                alt=""
              />
            </div>
            <div class="tli FeeFormBody baifenbi">4%</div>
            <div class="tli FeeFormBody jinqian">+40.000€</div>
          </div>
          <div class="tul FeeFormBody">
            <div class="tli FeeFormBody">
              <img
                src="../../assets/newImg/footlist/dengji/WechatIMG75.png"
                alt=""
              />
            </div>
            <div class="tli FeeFormBody baifenbi">5%</div>
            <div class="tli FeeFormBody jinqian">+30.000€</div>
          </div>
          <div class="tul FeeFormBody">
            <div class="tli FeeFormBody">
              <img
                src="../../assets/newImg/footlist/dengji/WechatIMG74.png"
                alt=""
              />
            </div>
            <div class="tli FeeFormBody baifenbi">6%</div>
            <div class="tli FeeFormBody jinqian">+20.000€</div>
          </div>
          <div class="tul FeeFormBody">
            <div class="tli FeeFormBody">
              <img
                src="../../assets/newImg/footlist/dengji/WechatIMG73.png"
                alt=""
              />
            </div>
            <div class="tli FeeFormBody baifenbi">7%</div>
            <div class="tli FeeFormBody jinqian">+10.000€</div>
          </div>
          <div class="tul FeeFormBody">
            <div class="tli FeeFormBody">
              <img
                src="../../assets/newImg/footlist/dengji/WechatIMG72.png"
                alt=""
              />
            </div>
            <div class="tli FeeFormBody baifenbi">8%</div>
            <div class="tli FeeFormBody jinqian">0€</div>
          </div>
        </div>
      </div>
      <!-- 佣金与价值 -->
      <div class="poundBodyMoudle commissionAndValue">
        <!-- 透明定价、阶梯佣金、成本优化 -->
        <h3>{{ $fanyi("透明定价、阶梯佣金、成本优化") }}</h3>
        <p>
          {{
            $fanyi(
              "以较低成本享受 Rakumart 的所有优势。透明且分级的佣金体系，助力您的业务增长。",
            )
          }}
        </p>
      </div>
      <!-- 手续费疑问 -->
      <div class="serviceFeeQuestion poundBodyMoudle">
        <div class="serviceFeeQuestionIconWrap">
          <img
            class="serviceFeeQuestionIcon"
            src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026061517555044958.svg"
            alt=""
          />
        </div>
        <div class="serviceFeeQuestionCon">
          <div class="serviceFeeQuestionText">
            <!-- 有任何疑问吗？请联系专业代理 -->
            <h3>{{ $fanyi("有任何疑问吗？请联系专业代理") }}</h3>
            <p>
              {{
                $fanyi(
                  "您是否正在寻找从中国进口的最佳解决方案？Rakumart就是答案，我们负责从产品购买到送达指定地址的整个过程。联系专业代理，开始享受我们的诸多优势吧。",
                )
              }}
            </p>
          </div>
          <!-- 与代理交谈 -->
          <button @click="openChat">{{ $fanyi("与代理交谈") }}</button>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Head from "../../components/head/HomePageTop.vue";
import Foot from "../../components/foot/Foot";
export default {
  // 页头：sr-only h1 供 SEO；可见文案恢复为 RAKUMART 的佣金（caption-kicker）
  data() {
    return {};
  },
  components: {
    Head,
    Foot,
  },
  computed: {
    evn() {
      // || location.origin == 'http://localhost:8080'
      if (
        location.origin == "https://www.rakumart.it" ||
        location.origin == "https://rakumart.eu" ||
        location.origin == "www.rakumart.it" ||
        location.origin == "http://www.rakumart.it"
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {},
  methods: {
    // 打开在线客服聊天窗口
    openChat() {
      this.$fun.clickJs();
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "../../css/mixin.scss";

.poundBody {
  padding-bottom: 50px;

  .poundBodyMoudle {
    width: 900px;
    margin: 0 auto;

    .caption {
      width: 640px;
      margin: 0 auto;
      padding: 0;
    }
  }

  .CommissionIsIntroduced {
    width: 1100px;

    margin: 60px auto 80px;
    padding: 10px;
    height: 307.39px;
    border-radius: 6px;
    background: #009246;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .IntroducedfontBox {
      width: 525.97px;
      height: 287.39px;
      padding: 50px;
      color: white;

      h1 {
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        line-height: 18px;
        letter-spacing: 2px;
        color: #ffc100;
        margin-bottom: 20px;
      }

      // 页头可见小标题（原 RAKUMART 的佣金 文案）
      .caption-kicker {
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        line-height: 18px;
        letter-spacing: 2px;
        color: #ffc100;
        margin-bottom: 20px;
      }

      h2 {
        font-size: 21px;
        font-weight: 500;
        line-height: 1.5em;
        margin-bottom: 20px;
      }

      p {
        font-size: 16px;
        font-weight: 400;
        line-height: 1.8em;
      }
    }

    .IntroducedfontImg {
      width: 451px;
      height: 361.54px;
      margin-right: 40px;
      transform: translateY(-10px);
    }
  }

  .handlingFeeRule {
    padding-top: 30px;

    .caption {
      // 与设计稿组 316 一致：640 宽、标题区与正文区间距 32px
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 32px;
      text-align: center;

      // 页头可见小标题（原 RAKUMART 的佣金 文案）
      .caption-kicker {
        color: #009246;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        margin-bottom: 0;
      }

      .captionContent {
        display: flex;
        flex-direction: column;
        gap: 24px;
        width: 100%;

        h3 {
          font-size: 26px;
          font-weight: 700;
          line-height: 30px;
          color: #000000;
          margin-bottom: 0;
        }

        p {
          font-size: 16px;
          font-weight: 400;
          line-height: 20px;
          color: #000000;
          margin-bottom: 0;
        }
      }
    }

    .handlingFeeForm {
      padding-top: 50px;

      .FeeFormTitle {
      }

      .FeeFormBody {
        .vipIcon {
          border: #009246 solid 5px;
          width: 53px;
          height: 53px;
          font-size: 18px;
          font-weight: 500;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
        }
      }

      .tul {
        display: flex;
        align-items: center;
        border-radius: 6px;

        &.FeeFormTitle {
          background: #f0f3f6;
        }

        &.FeeFormBody {
          &:nth-child(2n + 1) {
            background-color: #f9f9fb;
          }
        }

        .tli {
          flex: 1;

          &.FeeFormTitle {
            background: #f0f3f6;
            height: 53px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #7d7f8f;
            font-size: 13px;
            font-weight: 600;
            letter-spacing: 2px;
          }

          &.FeeFormBody {
            height: 75px;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 53px;
              height: 53px;
            }

            &.baifenbi {
              font-size: 24px;
              font-weight: 400;
              line-height: 14px;
            }

            &.jinqian {
              color: #808191;
              font-size: 21px;
              font-weight: 400;
              line-height: 14px;
            }
          }
        }
      }
    }
  }

  .commissionAndValue {
    text-align: center;
    margin-top: 50px;
    padding: 10px;

    h3 {
      color: var(--e-global-color-1792e67);
      font-family: "Open Sans", Sans-serif;
      font-size: 21px;
      font-weight: 500;
      line-height: 1.5em;
      margin-bottom: 20px;
    }

    p {
      width: 611px;
      margin: 0 auto 14.4px;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      line-height: 1.8em;
    }
  }

  .serviceFeeQuestion {
    // 与设计稿组 394 一致：1200 宽容器、#F9F9F9 背景、圆角 24px
    width: 1200px;
    margin-top: 50px;
    margin-bottom: 30px;
    padding: 80px 160px;
    background-color: #f9f9f9;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;

    .serviceFeeQuestionIconWrap {
      // 与设计稿组 343 一致：48px 蓝色圆底 #1DC7D3
      width: 48px;
      height: 48px;
      border-radius: 24px;
      background: #1dc7d3;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .serviceFeeQuestionIcon {
      width: 32px;
      height: 32px;
      display: block;
    }

    .serviceFeeQuestionCon {
      width: 640px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 32px;

      .serviceFeeQuestionText {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        width: 100%;

        > h3 {
          font-size: 21px;
          font-weight: 600;
          line-height: 30px;
          color: #000000;
          text-align: center;
          margin-bottom: 0;
        }

        > p {
          font-family: "Open Sans", Sans-serif;
          font-size: 16px;
          font-weight: 400;
          line-height: 20px;
          color: #000000;
          text-align: center;
          margin-bottom: 0;
        }
      }

      > button {
        // 与设计稿「Hablar con un agente」一致：品牌色/主色 #009246，白字，圆角 12px
        // min-width 保留设计最小宽度；width 不设死值，避免左右 padding 挤压导致意大利语文案换行
        box-sizing: border-box;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 321px;
        height: 60px;
        padding: 20px 80px;
        white-space: nowrap;
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        border-radius: 12px;
        border: none;
        background: #009246;
        color: #ffffff;
        transition: background-color 0.3s;
        cursor: pointer;

        &:hover {
          background-color: #2a6418;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
